import React from 'react'

export default function Input({title, placeholder, type, search, className}) {
    return (
        <div className="inputGroup">
            
            <h4>{title}</h4>
            {search?        
               <label className="searchIcon" >            <input className={type } style={{paddingLeft: '30px',         width:' calc(100% - 40px)'
}} type={type?type:"text"} placeholder={placeholder} />
 </label>
  :  <input className={className} type={type?type:"text"} placeholder={placeholder} />}
           
        </div>
    )
}
